import Luiv3Constants from '@app/lui3/constants';
import {PropsWithChildren} from 'react';
import styled from 'styled-components';

import Footer from './Footer';

interface Props extends PropsWithChildren {
  footerChildren: React.ReactNode;
}

const Wrapper = styled.div`
  border-radius: 1.5rem;
  box-shadow: 0 0.4375rem 1.75rem 0 rgba(3, 6, 12, 0.24);
  width: 600px;
  background-color: ${Luiv3Constants.baseColor['gray-0']};
`;

const Card = styled.div`
  padding: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-height: 720px;
  overflow-y: auto;
`;

const ModalContainer = ({children, footerChildren}: Props) => {
  return (
    <Wrapper>
      <Card>{children}</Card>
      <Footer>{footerChildren}</Footer>
    </Wrapper>
  );
};

export default ModalContainer;
